export class DateRange {
   
   constructor(from, to) {
      this.from = new Date(from);
      this.to   = new Date(to);
   }
   
   hasDate(date) {
      if ((date instanceof Date) === false) date = new Date(Date.fromString(date));
      return this.from <= date && this.to >= date;
   }
   
   hasIntersection(range) {
      return this.hasDate(range.from) || this.hasDate(range.to) || (this.from > range.from && this.to < range.to);
   }
   
}